import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useIsAdmin } from "@/hooks/useIsAdmin";
import { useAuth } from "@/contexts/AuthProvider";
import { useMode } from "@/contexts/ModeContext";
import { useQuery } from "@tanstack/react-query";

export const useNavbarLogic = () => {
  const { user } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const { isAdmin } = useIsAdmin();
  const { isArtist } = useMode();

  const { data: profile } = useQuery({
    queryKey: ["profile-min", user?.id],
    queryFn: async () => {
      if (!user?.id) return null;
      const { data, error } = await supabase
        .from("profiles")
        .select("user_type, avatar_url")
        .eq("id", user.id)
        .maybeSingle();
      
      if (error) {
        console.error('Navbar profile fetch error:', error);
        return null;
      }
      
      return data;
    },
    enabled: !!user?.id,
    staleTime: 30000,
    gcTime: 300000,
  });

  // Artists can do everything (sell + buy), buyers can only buy
  const showArtistContent = profile?.user_type === "artist";
  const showBuyerContent = true; // Everyone can buy

  const handleSignOut = async () => {
    await supabase.auth.signOut();
  };

  // Removed: cart sheet no longer opens on add - popup handles this now

  return {
    user,
    profile,
    isAdmin,
    isArtist,
    showArtistContent,
    showBuyerContent,
    handleSignOut,
    mobileMenuOpen,
    setMobileMenuOpen,
    cartOpen,
    setCartOpen,
  };
};
